import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CalendarGroup } from 'src/app/classes/calendar';
import { UserService } from 'src/app/services/user.service';
import { User } from 'src/app/classes/user';
import { CalendarService } from 'src/app/services/calendar.service';
import { accordeonMe } from 'src/app/animations';



@Component({
	selector: 'app-calendar-group-management',
	templateUrl: './calendar-group-management.component.html',
	styleUrls: [ '../management-interface.css', '../accordeon-ui.scss' ],
	animations: [ accordeonMe ],
})
export class CalendarGroupManagementComponent implements OnInit, OnDestroy {


	elements: CalendarGroup[] = [];
	currentFilter = "";
	filteredElements: CalendarGroup[] = [];
	expandedElementId = "";

	sortingField = 'vgName';
	sortingAsc = true;

	bLoading = true;
	subscriptions = new Subscription();

	users: User[] = [];


	constructor(
		private userService: UserService,
		private matDialog: MatDialog,
		private calendarService: CalendarService
	) {}


	ngOnInit() {

		this.userService.getAll().subscribe( users => {
			
			this.users = users;

			this.calendarService.getCalendarGroups().subscribe( calendarGroups => {

				this.elements = calendarGroups.sort( (a,b) => a.vgName.localeCompare( b.vgName ) );
				this.sortElements();
				this.bLoading = false;

			});

		});

	}


	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}


	sortColumn( field: string ) {

		if( this.sortingField === field ) {
			this.sortingAsc = !this.sortingAsc;
		} else {
			this.sortingField = field;
			this.sortingAsc = true;
		}

		this.sortElements();

	}

	sortElements() {

		this.elements.sort( ( a, b ) => {

			const valueA = (a.vgName || '').toString();
			const valueB = (b.vgName || '').toString();
		
			return this.sortingAsc ? valueA.localeCompare( valueB ) : valueB.localeCompare( valueA );

		});

		this.applyFilter();

	}

	clickOnRow( elementId: string ) {

		const bPrevious = !!this.expandedElementId;

		this.expandedElementId = ( this.expandedElementId == elementId ) ? "" : elementId;

		if( bPrevious && this.expandedElementId ) {
			setTimeout( () => {
				const elem = window.document.getElementById( "elementRow_" + elementId );
				if( elem ) {
					elem.scrollIntoView( { behavior: "smooth", block: "start" } );
				}
			}, 500 );
		}

	}

	onFilterChanged( event: Event ) {

		this.currentFilter = (event.target as HTMLInputElement).value.trim().toLocaleLowerCase(); 
		this.applyFilter();

	}

	private applyFilter() {

		this.filteredElements = this.elements.filter( u => {

			if( !u.vgName ) return false;
			const str = ("" + u.vgName).toLowerCase();
			if( str.includes( this.currentFilter ) ) return true;

			return false;

		});

	}

	showCreationDialog() {

		this.matDialog.open( CalendarGroupCreatorDialog, {
			maxHeight: '90vh', 
		}).afterClosed().subscribe( () => {
			this.sortElements();
		});

	}


	onCalendarGroupDeleted( calendarGroup: CalendarGroup ) {

		const i = this.elements.findIndex( r => r.vgId === calendarGroup.vgId );
		if( i == -1 ) return;

		this.elements.splice( i, 1 );
		this.sortElements();

	}

}



@Component( {
	selector: 'group-creator-dialog',
	template: `
		<app-calendar-group-editor 
			[users]="users" 
			(done)="creationDone()"
		/>
	`
})
export class CalendarGroupCreatorDialog {

	constructor(
		public dialogRef: MatDialogRef<CalendarGroupCreatorDialog>,
		@Inject(MAT_DIALOG_DATA) public users: User[],
	) {}

	creationDone() {
		this.dialogRef.close();
	}

}
